import { LOGGED_OUT } from 'actions/types';
import { CREDIT_SCORE_GET_ALERTS_SUCCESS, CREDIT_SCORE_MARK_ALERTS_READ_REQUEST, CREDIT_SCORE_RESET_DATA, } from '../actions/types';
const initialState = {
    alerts: [],
    isLimited: false,
    unreadCount: 0,
};
const creditAlertsReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOGGED_OUT:
        case CREDIT_SCORE_RESET_DATA: {
            return initialState;
        }
        case CREDIT_SCORE_GET_ALERTS_SUCCESS: {
            return {
                ...state,
                alerts: action.payload.alerts,
                isLimited: action.payload.isLimited,
                unreadCount: action.payload.unreadCount,
            };
        }
        case CREDIT_SCORE_MARK_ALERTS_READ_REQUEST: {
            const { alertIds } = action.extra;
            const markAll = alertIds.length === 0;
            const idSet = new Set(alertIds);
            const matches = (alert) => markAll || idSet.has(alert.alertId);
            const decrement = state.alerts.reduce((count, alert) => (!alert.isRead && matches(alert) ? count + 1 : count), 0);
            const alerts = state.alerts.map((alert) => !alert.isRead && matches(alert) ? { ...alert, isRead: true } : alert);
            return {
                ...state,
                alerts,
                unreadCount: Math.max(0, state.unreadCount - decrement),
            };
        }
        default:
            return state;
    }
};
export default creditAlertsReducer;
